import { buyerListingTitleTabs } from "../../../utils/constants";
export { syncRevisedEcoeDelayedReasonVisibility } from "../columnVisibilityUtils";

export const defaultNonVisibleColumnsArray = [
  "buyerAddress",
  "broadBandDescription",
  "closingAptTime",
  "qaWalkDate",
  "lastContact",
  "contactMethod",
  "realtorName",
  "realtorEmail",
  "conciergeName",
  "conciergeEmail",
  "trenchDate",
  "planNumber",
  "planDescription",
  "electricity",
  "gas",
  "water",
  "solarType",
  "flooring",
  "estimatedDeliverableDate",
  "mortgageType",
  "loanForeignNationalLoan",
  "loanOfficerName",
  "loanOfficerEmail",
  "loanStatus",
  "loanConditionalApproval",
  "loanApprovalSF",
  "loanSigning",
  "oslLoanGrade",
  "osls/0/name",
  "osls/0/email",
  "osls/0/phone",
  "osls/0/lockExpiery",
  "osls/0/type",
  "osls/0/status",
  "osls/0/condApproval",
  "osls/0/approval",
  "osls/1/name",
  "osls/1/email",
  "osls/1/phone",
  "osls/1/lockExpiery",
  "osls/1/type",
  "osls/1/status",
  "osls/1/condApproval",
  "osls/1/approval",
  "ostName",
  "ostEmail",
  "loanGrade",
  "loanDeclined",
  "contingent",
  "homeToCloseDate",
  "nhcEmail",
  "planElev",
  "intPkg",
  "extPkg",
  "constructionComplete",
  "certOfOccupancy",
  "titleStatus",
  "closingDocsSent",
  "qaManager",
  "NHADate",
  "totalOptions",
  "optionIncentive",
  "totalPrice",
  "paymentsCollected",
  "paymentsRemaining",
  "revenueSubtotal",
  "finalSalesPrice",
  "preConstruction",
  "preDrywall",
  "closeOfEscrowActual",
  "finalSignOff",
  "homesitePhase",
  "loanLockExpirationDate",
  "loanComment",
  "loanGradeSFMortgage",
  "propertyAppraisalOrderDate",
  "propertyAppraisalReceiveDate",
  "cdApprovedDate",
  "loanClosingDate",
  "titleCompany",
  "escrowClosingDate",
  "escrowOfficer",
  "loanProcessorName",
  "lennarTrackConsent",
  "packageDeliveredToLender",
  "lenderDocsReceived",
  "homeToClose",
  "revisedTitleCompany",
];

export const defaultTabOption = {
  title: buyerListingTitleTabs.myView,
  width: 150,
  value: 0,
};

export const optionsTabs = [
  defaultTabOption,
  {
    title: buyerListingTitleTabs.buyerDetails,
    width: 150,
    value: 1,
  },
  {
    title: buyerListingTitleTabs.homesiteDetails,
    width: 150,
    value: 2,
  },
  {
    title: buyerListingTitleTabs.mortgageTitleDetails,
    width: 150,
    value: 3,
  },
  {
    title: buyerListingTitleTabs.oslDetails,
    width: 150,
    value: 4,
  }
];
